import React, { useState } from "react";
import { useOrganizationUsers } from "../../../hooks/useOrganizationUsers";
import { UserList } from "../../../components/Organization/user-list.component";

export function LazyUserList({ organizationId }: { organizationId: number }) {
  const [enabled, setEnabled] = useState(false);
  const vm = useOrganizationUsers(organizationId, { enabled });

  return (
    <UserList
      users={vm.users}
      onCreate={vm.onCreateUser}
      onDelete={vm.onDeleteUser}
      onToggle={(isOpen) => {
         if (isOpen) setEnabled(true);
      }}
    />
  );
}
